module.exports = __webpack_public_path__ + "static/media/idlepage-products.8edb57ed.svg";